import React, { useState, useEffect } from 'react'

function FlightOffers() {
    const [offers, setOffers] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        const fetchOffers = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/flight-offers/`)
                if (!response.ok) {
                    throw new Error('Failed to fetch offers')
                }
                const data = await response.json()
                setOffers(data.results || [])
                setLoading(false)
            } catch (err) {
                setError(err.message)
                setLoading(false)
            }
        }

        fetchOffers()
    }, [])

    if (loading) {
        return (
            <section className="flight-offers-section py-5">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    if (error || offers.length === 0) {
        return (
            <section className="flight-offers-section py-5">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <h2 className="section-title mb-4">Special Flight Offers</h2>
                            <p className="text-muted">No offers available at the moment.</p>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    return (
        <section className="flight-offers-section py-5">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center mb-5">
                        <h2 className="section-title mb-4">Special Flight Offers</h2>
                        <p className="section-subtitle">Discover amazing deals on flights to your favorite destinations</p>
                    </div>
                </div>
                <div className="row">
                    {offers.map((offer) => (
                        <div key={offer.id} className="col-lg-4 col-md-6 mb-4">
                            <div className="flight-offer-card card border-0 shadow-sm h-100">
                                <div className="card-img-wrapper position-relative overflow-hidden">
                                    <img 
                                        src={offer.image || '/assets/img/normal/offer_img_1.jpg'} 
                                        className="card-img-top" 
                                        alt={offer.title}
                                        style={{ height: '200px', objectFit: 'cover' }}
                                    />
                                    {offer.discount_percentage && (
                                        <div className="discount-badge position-absolute top-0 end-0 bg-danger text-white p-2 m-2 rounded">
                                            {offer.discount_percentage}% OFF
                                        </div>
                                    )}
                                </div>
                                <div className="card-body d-flex flex-column">
                                    <h5 className="card-title mb-3">{offer.title}</h5>
                                    <p className="card-text flex-grow-1">{offer.description}</p>
                                    <div className="offer-details mb-3">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span className="text-muted">
                                                <i className="fas fa-map-marker-alt me-1"></i>
                                                {offer.destination}
                                            </span>
                                            {offer.airline && (
                                                <span className="text-muted">
                                                    <i className="fas fa-plane me-1"></i>
                                                    {offer.airline.name}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="offer-price mb-3">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                {offer.original_price && offer.original_price > offer.price && (
                                                    <span className="text-decoration-line-through text-muted me-2">
                                                        ${offer.original_price}
                                                    </span>
                                                )}
                                                <span className="fw-bold text-primary fs-4">
                                                    ${offer.price}
                                                </span>
                                            </div>
                                            <small className="text-muted">per person</small>
                                        </div>
                                    </div>
                                    {offer.valid_until && (
                                        <div className="offer-validity mb-3">
                                            <small className="text-warning">
                                                <i className="fas fa-clock me-1"></i>
                                                Valid until {new Date(offer.valid_until).toLocaleDateString()}
                                            </small>
                                        </div>
                                    )}
                                    <button className="btn btn-primary w-100 mt-auto">
                                        <i className="fas fa-ticket-alt me-2"></i>
                                        Book Now
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default FlightOffers
